import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { PersonRequest, PersonResponse } from '../models/person';

/**
 * <p>
 * API endpoints that cover all project related CRUD calls
 */
export const personApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    searchPerson: builder.query<PaginationResponse<PersonResponse>, PersonRequest>({
      query: (params: PersonRequest) => ({
        url: encodeURI(
          `/approvers/person/search?searchTerm=${params.searchTerm}&page=${params.page}&size=${params.size}&sortKey=${params.sortKey}&sortDirection=ASC`,
        ),
      }),
      providesTags: ['Person'],
    }),
  }),
});

export const { useSearchPersonQuery } = personApi;
